import { render, staticRenderFns } from "./trademarklookout-details.vue?vue&type=template&id=5cb0a674&scoped=true&"
import script from "./trademarklookout-details.vue?vue&type=script&lang=js&"
export * from "./trademarklookout-details.vue?vue&type=script&lang=js&"
import style0 from "./trademarklookout-details.vue?vue&type=style&index=0&id=5cb0a674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb0a674",
  null
  
)

export default component.exports